import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_NO: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitness',
  components_header_media_1: 'For Menn',
  components_header_media_2: 'For Kvinner',
  components_header_media_multi_content_2: 'Yoga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Tren smartere, føl deg bedre.',
  hero_button_text: 'Kom i gang nå',
  components_ressources_subheader_text: 'Guider og tips',
  components_ressources_span_text: 'Den kombinerer det jordnære fokuset fra yoga, den kontrollerte presisjonen fra pilates og den dynamiske utfordringen fra styrketrening for å støtte en allsidig og sunn livsstil.',
  components_ressources_card_1_title: 'Yoga tips',
  components_ressources_card_1_text: 'Rask veiledning for bedre balanse, pust og flyt.',
  components_ressources_card_2_title: 'Pilates tips',
  components_ressources_card_2_text: 'Enkle tips for å styrke kjernemuskulaturen og forbedre kontrollen.',
  components_notes_and_google_title_1: 'Bygg styrke',
  components_notes_and_google_title_2: 'Yoga Ro',
  components_notes_and_google_title_3: 'Pilates kjerne',
  media_content_section_multi_1_subheader_text: 'Treningsvideoer',
  media_content_section_multi_2_subheader_text: 'Yogavideoer',
  media_content_section_multi_3_subheader_text: 'Pilatesvideoer',
  text_media_1: 'Menn',
  text_media_2: 'Kvinner',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Tilbake',
  page_media_content_menu_chest: 'Kiste',
  page_media_content_menu_legs: 'Bein',
  page_media_content_menu_shoulders: 'Skuldre',
  page_media_content_menu_abdominals: 'Magemuskler',
  components_text1_subheader_text: 'Sunt kosthold for ditt aktive liv',
  components_text1_span_text: 'Sunne oppskrifter som støtter treningen din og forbedrer velværet ditt.',
  components_footer_text: 'Styrk kroppen din, balanser sinnet ditt og beveg deg med mening – din plass til treningsstudio, yoga og pilates.',
};